import React from 'react';

function Grupos() {
    return (
        <div className="m-5 projetos-container">
            <h2>Grupos de Estudos no Instituto Pasqualin</h2>
            <br></br>
            <p className="fw-bold">Espaços de Reflexão, Troca e Construção Coletiva de Saberes</p>

            <span>Os Grupos de Estudos do Instituto Pasqualin são criados para promover o aprofundamento teórico, o diálogo crítico e a articulação de práticas
                transformadoras no campo da Psicologia, Educação e Direitos Humanos. Voltados para profissionais, estudantes e interessados(as) em temáticas sociais,
                nossos grupos oferecem um ambiente colaborativo e acolhedor, onde as trocas de experiências e saberes contribuem para a construção de novas
                perspectivas.</span>

            <br></br>
            <hr></hr>
            <br></br>
            <p className="fw-bold">Objetivos dos Grupos de Estudos</p>

            <ol>
                <li><strong>Fomentar Reflexões Críticas:</strong> Promover debates e leituras que questionem práticas normativas e ampliem a visão sobre desigualdades e direitos humanos.</li>
                <li><strong>Aproximar Teoria e Prática:</strong> Relacionar conceitos teóricos às experiências concretas de atuação profissional.</li>
                <li><strong>Criar Redes de Colaboração:</strong> Estimular o compartilhamento de vivências e estratégias entre participantes.</li>
                <li><strong>Produzir Conhecimento Coletivo:</strong> Sistematizar aprendizados que possam ser aplicados no enfrentamento das desigualdades sociais.</li>
            </ol>


            <br></br>
            <hr></hr>
            <br></br>
            <p className="fw-bold">Temáticas Disponíveis</p>

            <span>Os grupos de estudos são organizados com base em temas atuais e relevantes, que dialogam com os valores e compromissos do Instituto Pasqualin.
                Algumas das temáticas incluem:</span>
            <ul>
                <li><strong>Psicologia Escolar e Educacional:</strong>
                    <ul>
                        <li> Inclusão, diversidade e enfrentamento ao fracasso escolar.</li>
                        <li> Saúde mental no ambiente educacional.</li>
                        <li> Relação entre psicologia, políticas públicas e direitos humanos na escola.</li>
                    </ul>
                </li>

                <li><strong>Diversidade e Direitos Humanos:</strong>
                    <ul>
                        <li> Estudos de gênero e sexualidade.</li>
                        <li> Enfrentamento ao racismo e às violências estruturais.</li>
                        <li> Questões de classe e justiça social.</li>
                    </ul>
                </li>

                <li><strong>Saúde Mental e Contextos Contemporâneos:</strong>
                    <ul>
                        <li> Desafios da saúde mental no trabalho e na sociedade.</li>
                        <li> Despatologização e práticas de cuidado comunitário.</li>
                        <li> Capacitismo e acessibilidade na Psicologia e na Educação.</li>
                    </ul>
                </li>

                <li><strong>Teorias Críticas e Pluralidade Epistemológica:</strong>
                    <ul>
                        <li> Estudos decoloniais e epistemologias do sul global.</li>
                        <li> Crítica à colonialidade no campo da Psicologia e da Educação.</li>
                    </ul>
                </li>
            </ul>

            <br></br>
            <hr></hr>
            <br></br>
            <p className="fw-bold">Formato e Estrutura</p>

            <ul>
                <li><strong>Duração:</strong> Encontros quinzenais ou mensais, com duração de 1h30min a 2h.</li>
                <li><strong>Formato:</strong> Online ou presencial, garantindo acessibilidade para participantes de diferentes localidades.</li>
                <li><strong>Metodologia:</strong> Leituras prévias, debates, dinâmicas reflexivas e análise de casos.</li>
                <li><strong>Facilitadores(as):</strong> Profissionais qualificados(as) com experiência acadêmica e prática nos temas abordados.</li>
            </ul>



            <br></br>
            <hr></hr>
            <br></br>
            <p className="fw-bold">Por que Participar dos Grupos de Estudos?</p>

            <ul>
                <li><strong>Ampliar Horizontes:</strong> Aprofundar conhecimentos em temáticas essenciais para a prática profissional e cidadã.</li>
                <li><strong>Construir Rede:</strong> Estabelecer conexões com pessoas que compartilham interesses e valores.</li>
                <li><strong>Desenvolvimento Contínuo:</strong> Atualizar-se em relação a debates teóricos e práticos relevantes.</li>
                <li><strong>Ação Transformadora:</strong> Qualificar-se para atuar como agente de mudança nos diferentes contextos de trabalho e vida.</li>
            </ul>



            <br></br>
            <hr></hr>
            <br></br>
            <p className="fw-bold">Para Quem?</p>

            <ul>
                <li><strong>Psicólogos(as) e estudantes de Psicologia.</strong></li>
                <li><strong>Educadores(as) e gestores(as) escolares.</strong></li>
                <li><strong>Profissionais e interessados(as) em direitos humanos e justiça social.</strong></li>
                <li><strong>Pessoas que desejam aprofundar reflexões e práticas comprometidas com a transformação social.</strong></li>
            </ul>



            <br></br>
            <hr></hr>
            <br></br>
            <p className="fw-bold">Inscrições e Informações</p>

            <span>Se você está em busca de um espaço que une teoria, prática e compromisso ético-político, os Grupos de Estudos do Instituto Pasqualin são para você!</span>
            <p className="mt-2 fw-bold">Entre em contato para conhecer os próximos temas e cronogramas.</p>
            <p className="mt-2 fw-bold">Participe e construa conosco saberes que transformam!</p>






        </div>
    );
}

export default Grupos;
